// tslint:disable
export enum EnrollmentSendTo {
    /**
     * @description Unknown location. Not a valid choice
     */
    Unknown = 0,
    /**
     * @description Send enrollment data to HealthSmart via Medical Activation Service
     */
    MedicalActivationServiceHealthSmart = 1,
}
(EnrollmentSendTo as any)['UNKNOWN'] = 0;
(EnrollmentSendTo as any)['MEDICALACTIVATIONSERVICEHEALTHSMART'] = 1;
